import React from "react";
import { FlexContainer } from "src/components";
import { 
    TextArea,
    TextLabel,
} from "../../style";

export const QuoteTextField = ({ value, onChange, isUpdate }) => {
    return (
        <FlexContainer>
            <TextLabel fontWeight="bold"> {isUpdate ? "Edit" : "Add"} Quote Text (Optional)</TextLabel>
            <TextLabel color="#612684" fontSize="15px">
                {isUpdate ? "Edit" : "Add"} the inspirational text that will appear over the background image. (Max 300 characters)
            </TextLabel>
            <TextArea
                name="description"
                value={value}
                placeholder="Type your quote here…"
                onChange={(e) => onChange(e.target.value)}
                disabled={false}
                maxLength={300} 
            />
        </FlexContainer>
    );
};
